// @ts-check
// Módulos cobrados à parte (3.0.0, contrato 10 de atendimento, seção 2): as chamadas do painel de suporte (/admin) que
// leem e mudam os módulos de uma escola. O estado do módulo na escola logada vem do /auth/me (metadata-store.js).
import { api } from './api-client.js';

const ADMIN_API = '/admin/api';

/**
 * @typedef {{ moduleKey: string, isEnabled: boolean, source: 'SUPPORT' | 'PLAN' | 'ENVIRONMENT', reason: string | null, note: string | null,
 *   changedByEmail: string | null, changedAt: string | null }} AdminTenantModule
 */

/** @param {string} tenantId @returns {Promise<AdminTenantModule[]>} */
export async function fetchAdminTenantModules(tenantId) {
  return (await api.get(`${ADMIN_API}/tenants/${tenantId}/modules`, undefined, { skipUnauthorizedRedirect: true })).data.modules;
}

/**
 * Liga ou desliga o módulo na escola (grava o D1 e depois o Durable Object; o servidor desfaz se o segundo falhar).
 * @param {string} tenantId @param {string} moduleKey @param {{ isEnabled: boolean, note?: string | null, confirmRestricted?: boolean }} input
 * @returns {Promise<AdminTenantModule[]>}
 */
export async function setAdminTenantModule(tenantId, moduleKey, input) {
  return (await api.put(`${ADMIN_API}/tenants/${tenantId}/modules/${moduleKey}`, input)).data.modules;
}
